import type { Schedule } from "./audit-data";
import type { CalendarEvent } from "../ui/calendar";
import type { Tone } from "../ui/tokens";

function pad(n: number): string {
  return n < 10 ? "0" + n : String(n);
}

// 表示月(year, month=0-11)におけるジョブ実行日を算出する。label/tone はジョブ別の表示用。
export function computeScheduleEvents(
  schedule: Schedule,
  year: number,
  month: number,
  label = "監査",
  tone?: Tone,
): CalendarEvent[] {
  if (schedule.frequency === "off") return [];
  const events: CalendarEvent[] = [];
  const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  for (let d = 1; d <= daysInMonth; d += 1) {
    const dow = new Date(Date.UTC(year, month, d)).getUTCDay();
    const hit =
      (schedule.frequency === "weekly" && dow === schedule.dayOfWeek) ||
      (schedule.frequency === "monthly" && d === schedule.dayOfMonth);
    if (hit) {
      events.push({
        date: year + "-" + pad(month + 1) + "-" + pad(d),
        label: label + " " + schedule.time,
        ...(tone !== undefined ? { tone } : {}),
      });
    }
  }
  return events;
}
